import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography, } from '@mui/material';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { clone } from 'lodash-es';
import { useStore } from '@mcn-platform/models';
import Quiz from './quiz/Quiz';
import { WysiwygViewer } from '../../publisher/wysiwyg/WysiwygEditor';
import AnswerResult from './quiz/AnswerResult';
const KnowledgeCheckPanel = ({ courseItem, progress, onEnd }) => {
    const store = useStore();
    const [displayMode, setDisplayMode] = useState('intro');
    const [blockInput, setBlockInput] = useState(false);
    const [started, setStarted] = useState(false);
    const { item: quizItem } = courseItem;
    const { id: quizID, questions, } = quizItem;
    const currentQuestion = questions[0];
    const quizResults = progress?.quizResults;
    const quizResult = quizResults?.[quizID];
    // console.log('quizResult', quizResult);
    const finishQuiz = useCallback((newQuizResult) => {
        const score = Math.floor((newQuizResult.answers.correct.length)
            * 100);
        newQuizResult.isCompleted = true;
        newQuizResult.score = score;
        newQuizResult.isPassed = score >= 80;
        newQuizResult.completedAt = new Date();
        newQuizResult.type = 'knowledgeCheck';
    }, []);
    const saveResults = useCallback(async (newQuizResults) => {
        progress.updateValues({ quizResults: newQuizResults });
        // TODO - if progress has a course field then its a courseProgres,
        // otherwise programProgress - use better logic for this
        await store.update((progress.course ? 'courseProgress' : 'programProgress'), progress);
        // console.log('quiz results saved', progress.quizResults);
    }, [progress, store]);
    const updateQuizProgress = useCallback(async (answer) => {
        setBlockInput(true);
        const history = clone(quizResult?.history || []);
        if (quizResult?.answers) {
            // quiz has been taken previously, move the answers
            // into a history array
            history.push({
                answers: quizResult.answers,
                isCompleted: quizResult.isCompleted,
                startedDate: quizResult.startedDate,
                completedAt: quizResult.completedAt,
            });
        }
        const newQuizResult = {
            answers: {
                correct: [...(answer?.isCorrect ? [answer.question] : [])],
                incorrect: [...(answer?.isCorrect ? [] : [answer.question])],
            },
            results: [{
                    question: answer.question.id,
                    isCorrect: answer.isCorrect,
                    userAnswers: answer.userAnswers,
                    inputValue: answer.inputValue,
                }],
            isStarted: true,
            history,
        };
        const newQuizResults = clone(quizResults);
        newQuizResults[quizID] = newQuizResult;
        finishQuiz(newQuizResult);
        await saveResults(newQuizResults);
        onEnd();
        setBlockInput(false);
    }, [
        finishQuiz,
        onEnd, quizID,
        quizResult?.answers,
        quizResult?.completedAt,
        quizResult?.history,
        quizResult?.isCompleted,
        quizResult?.startedDate,
        quizResults,
        saveResults,
    ]);
    const handleAnswer = (answer) => {
        updateQuizProgress(answer);
        setDisplayMode('answer');
    };
    const startKnowledgeCheck = async () => {
        if (!(progress)) {
            console.log('Missing progress record, cant do quiz');
            return;
        }
        // unlike with quiz - Knowledge Check stores history when the question is answered.
        // const history = clone(quizResult?.history || []);
        // if (quizResult?.answers) {
        //   // quiz has been taken previously, move the answers
        //   // into a history array
        //   history.push({
        //     answers: quizResult.answers,
        //     isCompleted: quizResult.isCompleted,
        //     startedDate: quizResult.startedDate,
        //     completedAt: quizResult.completedAt,
        //   });
        // }
        setDisplayMode(quizResult?.isCompleted ? 'answer' : 'question');
        // const newQuizResult = {
        //   answers: {
        //     correct: [],
        //     incorrect: [],
        //   },
        //   isStarted: true,
        //   history,
        // };
        // // this is the quizResult for this quiz
        // // TODO - data manipulation belongs in the model
        // const newQuizResults = clone(quizResults);
        // newQuizResults[quizID] = newQuizResult;
        // await saveResults(newQuizResults);
    };
    useEffect(() => {
        setStarted(false);
    }, [quizID]);
    if (!started) {
        setStarted(true);
        startKnowledgeCheck();
    }
    console.log('knowlege check progress', progress);
    return (_jsx(Box, { sx: {
            bgcolor: 'white',
            p: 2,
            minHeight: 400,
        }, children: _jsxs(Box, { sx: {
                mx: 4,
            }, children: [_jsx(Box, { sx: { position: 'relative' }, children: courseItem.item?.instructions?.slate && (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "div", variant: "subtitle1", fontWeight: "fontWeightBold", children: "Instructions:" }), _jsx(Box, { className: "slate", children: _jsx(WysiwygViewer, { id: courseItem.id, value: courseItem.item.instructions.slate }) })] })) }), _jsx(Box, { children: courseItem.item.questions.length ? (_jsx(Box, { sx: { py: 1 }, children: displayMode === 'answer' ? (_jsx(AnswerResult, { answerCorrect: quizResult?.isPassed })) : (_jsx(Quiz, { question: currentQuestion, nextQuestion: handleAnswer, setCourseResult: handleAnswer, isKnowledgeCheck: true, blockInput: blockInput, showAnswer: false })) })) : '' })] }) }));
};
export default observer(KnowledgeCheckPanel);
//# sourceMappingURL=KnowledgeCheckPanel.js.map